import React, { useState, useEffect, useContext } from "react";
import { SimpleForm } from "simple-ui-components";

import { FilterByStyled } from "../../theme";
import { get } from "../../server-requests/serverRequests";
import { AuthContext } from "../authContextProvider";
import { LoadingBox } from "../shared/loading";
import { getTranslation } from "../languageProvider";
import { Log, ReplaceWord } from "../shared/utility";

export const FilterEquipmentByModel = ({ Selected }) => {
  const { InputGroup } = SimpleForm;
  const { snackbarHandler } = useContext(AuthContext);

  // brand
  const [reloadBrand, setReloadBrand] = useState(true);
  const [brandList, setBrandList] = useState([]);
  const [loadingBrand, setLoadingBrand] = useState(true);
  const [selectedBrand, setSelectedBrand] = useState([]);

  // model
  const [reloadModel, setReloadModel] = useState(false);
  const [modelList, setModelList] = useState([]);
  const [loadingModel, setLoadingModel] = useState(false);
  const [selectedModel, setSelectedModel] = useState([]);

  // get Models List
  useEffect(() => {
    let isMounted = true;
    if (reloadModel && selectedBrand.length > 0) {
      setModelList([]);
      setSelectedModel([]);
      get("models/list", {
        brandId: selectedBrand[0].id,
      })
        .then((model) => {
          if (isMounted) {
            let formattedModel = [];
            if (model.length > 0)
              formattedModel = model.map((item) => ({
                label: item.name,
                ...item,
              }));
            setModelList(formattedModel);
            setReloadModel(false);
            setLoadingModel(false);
          }
        })
        .catch((status) => {
          snackbarHandler(getTranslation(`error${status}`));
          setReloadModel(false);
          setLoadingModel(false);
          Log("Error: get models/list" + status);
        });
    }
    return () => (isMounted = false);
  }, [reloadModel, selectedBrand, snackbarHandler]);

  // get Brand List
  useEffect(() => {
    let isMounted = true;
    if (reloadBrand) {
      get("brands/list")
        .then((brand) => {
          if (isMounted) {
            let formattedBrand = [];
            if (brand.length > 0)
              formattedBrand = brand.map((item) => ({
                label: item.name,
                companyName: item.company.name,
                ...item,
              }));
            setBrandList(formattedBrand);
            setLoadingBrand(false);
            setReloadBrand(false);
          }
        })
        .catch((status) => {
          snackbarHandler(getTranslation(`error${status}`));
          setLoadingBrand(false);
          setReloadBrand(false);
          Log("Error: get brand/list" + status);
        });
    }
    return () => (isMounted = false);
  }, [reloadBrand, snackbarHandler]);

  const brandChangeHandler = (brand) => {
    setSelectedBrand(brand);
    setReloadModel(true);
  };
  const modelChangeHandler = (model) => {
    setSelectedModel(model);
    if (model.length > 0) Selected(model[0]);
  };

  return (
    <FilterByStyled className="outline md">
      {loadingBrand && (
        <LoadingBox height={40} width="100%" styles={{ marginBottom: 20 }} />
      )}
      {brandList.length > 0 && !loadingBrand && (
        <InputGroup
          type="autocomplete"
          placeholder={getTranslation("0103")}
          inputElement={{
            id: "brandList",
            list: brandList,
            change: brandChangeHandler,
            value: selectedBrand,
            className: selectedBrand.length > 0 ? "focused" : "",
            placeholder: getTranslation("0036"),
            inputPlaceholder: `${getTranslation("0036")}/${getTranslation(
              "0052"
            )}`,
            emptyText: ReplaceWord(
              getTranslation("0048"),
              "**LIST**",
              getTranslation("0036").toLowerCase()
            ),
            multiple: false,
            clear: true,
            secondaryOption: "companyName",
          }}
        />
      )}
      {selectedBrand && loadingModel && (
        <LoadingBox height={40} width="100%" styles={{ marginBottom: 20 }} />
      )}
      {selectedBrand.length > 0 && modelList.length > 0 && !loadingModel && (
        <InputGroup
          type="autocomplete"
          placeholder={getTranslation("0104")}
          inputElement={{
            id: "modelList",
            list: modelList,
            change: modelChangeHandler,
            value: selectedModel,
            className: selectedModel.length > 0 ? "focused" : "",
            placeholder: getTranslation("0085"),
            inputPlaceholder: getTranslation("0124"),
            emptyText: ReplaceWord(
              getTranslation("0048"),
              "**LIST**",
              getTranslation("0085").toLowerCase()
            ),
            multiple: false,
            clear: true,
          }}
        />
      )}
    </FilterByStyled>
  );
};
